<template>
    <div v-bind:class="[{ busy: loadingFavorites }]" class="article-dropdown-container opacity-transition">
        <pb-spinner v-if="loadingFavorites"/>
        <div v-else-if="favorites.length > 0">
            <div class="inner">
                <article-preview :key="favorite.id" v-for="(favorite) in favorites"
                                 :thumbnail="favorite.articleVariant ? favorite.articleVariant.thumbnail : favorite.articleDetails.webImage"
                                 :article-details="favorite.articleDetails"
                                 :to="{ name: 'ar', params: {articleId: favorite.articleDetails.id, categoryId: favorite.categoryId, variantId: favorite.articleVariant ? favorite.articleVariant.articleColor.id : null} }">
                </article-preview>
            </div>
        </div>
        <div v-else class="py-3 text-center">
            No favorite items added yet
        </div>
    </div>
</template>
<script>

    import {mapGetters, mapState} from "vuex";
    import ArticlePreview from "../../../../../components/dropdown-nav/ArticlePreview";

    export default {
        name: 'favorites-dropdown',
        components: {
            'article-preview': ArticlePreview
        },
        computed: {
            ...mapState('favorites', ['loadingFavorites']),
            ...mapGetters('favorites', ['favorites'])
        }
    }
</script>